var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"sns_m"}},[_c('div',{staticClass:"sns_m"},[_c('iframe',{ref:"iframe",attrs:{"src":_vm.iframeURL,"frameborder":"0","id":"iframe"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }